import {setUser} from '../../utils';
export default {
  setUser: (state, value) => {
    state.user = value;
    setUser(value);
  }
}
